/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Password_UpdatedInputs */

const en_common_password_updated = /** @type {(inputs: Common_Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully updated password`)
};

const es_common_password_updated = /** @type {(inputs: Common_Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña actualizada correctamente`)
};

/**
* | output |
* | --- |
* | "Successfully updated password" |
*
* @param {Common_Password_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_password_updated = /** @type {((inputs?: Common_Password_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Password_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_password_updated(inputs)
	return en_common_password_updated(inputs)
});